module.exports = __webpack_public_path__ + "files/userImportSample.8c0af26a.xls";